import { useQuery } from "@tanstack/react-query";
import { settingsApi, type SiteSetting } from "@/integrations/mysql/client";

export type { SiteSetting };

export function useSiteSettings() {
  const { data: settings, isLoading, refetch } = useQuery({
    queryKey: ['site-settings'],
    queryFn:  async () => {
      const rows = await settingsApi.list();
      const map: Record<string, string> = {};
      if (Array.isArray(rows)) rows.forEach((s) => { map[s.key] = s.value ?? ''; });
      return map;
    },
    staleTime: 1000 * 60 * 5,
  });

  const getSetting = (key: string, defaultValue = '') =>
    settings?.[key] ?? defaultValue;

  return { settings: settings ?? {}, isLoading, refetch, getSetting };
}
